import ImgCalendarProvider from '@/components/ImgCalendarProvider';
import IConnectedCalendar from '@/types/IConnectedCalendar';
import { Box, Checkbox, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { VscChevronDown } from 'react-icons/vsc';

interface ICalendarProps extends IConnectedCalendar {
	isLoading: boolean;
	isOpen: boolean;
	isReadOnly: boolean;
	onChangeWrite: (calendarId: string, value: boolean) => void;
	onChangeRead: (calendarId: string, value: boolean) => void;
}

export default function Calendar(props: ICalendarProps) {
	const { t } = useTranslation();

	return (
		<details open={props.isOpen}>
			<Flex
				as="summary"
				borderBottom="1px solid var(--chakra-colors-chakra-border-color)"
				cursor="pointer"
				overflow="hidden"
				textOverflow="ellipsis"
				width="100%"
				_hover={{
					backgroundColor: 'var(--chakra-colors-blackAlpha-50)',
				}}
				_first={{ borderTop: '1px solid var(--chakra-colors-chakra-border-color)' }}
				_last={{ borderBottom: 'none' }}
			>
				<Flex alignItems="center" mr="3" ml="3">
					<ImgCalendarProvider size="4" {...props} />
				</Flex>

				<Flex flexDir="column" p="2" mr="auto">
					<Text>{props.name}</Text>
				</Flex>

				<Box display="grid" pr="5" justifyContent="center" alignContent="center">
					<VscChevronDown />
				</Box>
			</Flex>

			<Flex flexDir="column" p="3">
				<Checkbox
					aria-label={t('Check availability on {{name}}', { name: props.name })}
					checked={props.verifyAvailability}
					cursor={props.isLoading ? 'wait!important' : 'pointer'}
					defaultChecked={props.verifyAvailability}
					isDisabled={props.isLoading}
					mt="2"
					onChange={(e) => props.onChangeRead(props.id, e.target.checked)}
					size="sm"
				>
					{t('Check availability on this calendar')}
				</Checkbox>

				<Checkbox
					aria-label={t('Create events on {{name}}', { name: props.name })}
					checked={props.syncBookings}
					cursor={props.isLoading ? 'wait!important' : 'pointer'}
					defaultChecked={props.syncBookings}
					isDisabled={props.isReadOnly || props.isLoading}
					mt="1"
					onChange={(e) => props.onChangeWrite(props.id, e.target.checked)}
					size="sm"
				>
					{t('Create events on this calendar')}
				</Checkbox>

				<Text mt="3" textAlign="right" fontSize="sm" color="gray.500">
					{props.account}
				</Text>
			</Flex>
		</details>
	);
}
